import ITokenSettings, { FilterBarVersion } from "@models/ITokenSettings";

export interface IFilterBarMode {
    /** Render the FilterBar (v2) instead of the legacy search section */
    useFilterBar: boolean;
    /** Show the legacy/v2 toggle (hidden for tokens stamped filter_bar_v2_only) */
    showToggle: boolean;
}

export interface IFilterBarModeOptions {
    /**
     * Always use the legacy search section and hide the toggle, regardless of token settings.
     * Used by the ecommerce Shipments view (`/ecomm/shipments`), which stays on the simpler classic filters.
     */
    forceLegacy?: boolean;
}

/**
 * Which search UI a user sees on the Orders, Quotes, Shipments and Purchase Orders screens.
 *
 * `filter_bar_v2_only` is stamped by the API on tokens created after the FilterBar shipped
 * and is never written by the UI. `filter_bar_version` is the user's own choice; absent means legacy.
 * `options.forceLegacy` overrides both for screens that never offer the FilterBar (ecommerce Shipments).
 */
export function getFilterBarMode(settings?: ITokenSettings | null, options?: IFilterBarModeOptions): IFilterBarMode {
    if (options?.forceLegacy) {
        return { useFilterBar: false, showToggle: false };
    }

    const v2Only = settings?.filter_bar_v2_only === true;
    const version: FilterBarVersion | undefined = settings?.filter_bar_version;

    return {
        useFilterBar: v2Only || version === "v2",
        showToggle: !v2Only,
    };
}
